<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>门店管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="门店ID"
                        prop="marketid">
            <el-input placeholder="请输入门店ID"
                      v-model="search.marketid"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="门店名称"
                        prop="marketname">
            <el-input placeholder="请输入门店名称"
                      v-model="search.marketname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="所属客户"
                        prop="customer">
            <el-input placeholder="请输入所属客户"
                      v-model="search.customer"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="门店地址"
                        prop="address">
            <el-input placeholder="请输入门店地址"
                      v-model="search.address"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="操作人"
                        prop="adminid">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入管理员名称搜索"
              v-model="search.adminid"
              :query-request="getBasicPlatformUsersIndex"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="数据源"
                        prop="datasource">
            <el-select v-model="search.datasource"
                       placeholder="请选择"
                       clearable>
              <el-option
                v-for="item in datasourceOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间"
                        prop="created_at">
            <el-date-picker
              v-model="search.created_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="省市区"
                        prop="regionids">
            <el-cascader
              v-model="search.regionids"
              class="width-max"
              :options="chinaAreaData"
              :props="{ multiple: true, checkStrictly: true }"
              filterable
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       size="mini"
                       native-type="submit">搜索
            </el-button>
            <el-button @click="resetSearch"
                       size="mini">重置
            </el-button>
            <el-button icon="el-icon-download"
                       size="mini"
                       @click="onExportSearch">按搜索结果导出
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-tooltip class="item"
                    effect="dark"
                    content="刷新"
                    placement="top">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-refresh"
                     @click="onRefresh()"></el-button>
        </el-tooltip>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="date"
                         label="日期"
                         min-width="100"></el-table-column>
        <el-table-column prop="admin_display"
                         label="操作人"
                         min-width="110"></el-table-column>
        <el-table-column prop="created_at"
                         label="操作时间"
                         min-width="160"
                         :formatter="formatCreatedAt"></el-table-column>
        <el-table-column prop="marketid"
                         label="门店ID"
                         min-width="80"></el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"
                         min-width="140"></el-table-column>
        <el-table-column prop="customer"
                         label="所属客户"
                         min-width="100"></el-table-column>
        <el-table-column prop="provincename"
                         label="省"
                         min-width="80"></el-table-column>
        <el-table-column prop="cityname"
                         label="市"
                         min-width="80"></el-table-column>
        <el-table-column prop="areaname"
                         label="区"
                         min-width="80"></el-table-column>
        <el-table-column prop="address"
                         label="详细地址"
                         min-width="160"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldlongitude"
                         label="原始经度"
                         min-width="110"></el-table-column>
        <el-table-column prop="oldlatitude"
                         label="原始纬度"
                         min-width="110"></el-table-column>
        <el-table-column prop="newlongitude"
                         label="修改后经度"
                         min-width="110"></el-table-column>
        <el-table-column prop="newlatitude"
                         label="修改后纬度"
                         min-width="110"></el-table-column>
        <el-table-column prop="datasource"
                         label="数据源"
                         min-width="90"></el-table-column>
        <el-table-column prop="userlongitude"
                         label="用户经度"
                         min-width="110"></el-table-column>
        <el-table-column prop="userlatitude"
                         label="用户纬度"
                         min-width="110"></el-table-column>
        <el-table-column prop="reclongitude"
                         label="推荐门店经度"
                         min-width="110"></el-table-column>
        <el-table-column prop="reclatitude"
                         label="推荐门店纬度"
                         min-width="110"></el-table-column>
        <el-table-column prop="recmarketname"
                         label="推荐门店名称"
                         min-width="140"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="recprovincecityarea"
                         label="推荐门店省市区"
                         min-width="140"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="recaddress"
                         label="推荐门店地址"
                         min-width="160"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="recscore"
                         label="推荐门店可信度打分"
                         min-width="140"></el-table-column>
        <el-table-column prop="recdistance"
                         label="推荐门店与系统门店距离"
                         min-width="160"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import { removeEmptyParams } from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      table: [],
      chinaAreaData: [],
      datasourceOpts: [
        { value: '用户位置', label: '用户位置' },
        { value: '智能推荐', label: '智能推荐' },
        { value: '手动查找', label: '手动查找' },
      ],
      exportHeader: [
        { key: 'date', text: '日期' },
        { key: 'admin_display', text: '操作人' },
        { key: 'created_at', text: '操作时间' },
        { key: 'marketid', text: '门店ID' },
        { key: 'marketname', text: '门店名称' },
        { key: 'customer', text: '所属客户' },
        { key: 'provincename', text: '省' },
        { key: 'cityname', text: '市' },
        { key: 'areaname', text: '区' },
        { key: 'address', text: '详细地址' },
        { key: 'oldlongitude', text: '原始经度' },
        { key: 'oldlatitude', text: '原始纬度' },
        { key: 'newlongitude', text: '修改后经度' },
        { key: 'newlatitude', text: '修改后纬度' },
        { key: 'datasource', text: '数据源' },
        { key: 'userlongitude', text: '用户经度' },
        { key: 'userlatitude', text: '用户纬度' },
        { key: 'reclongitude', text: '推荐门店经度' },
        { key: 'reclatitude', text: '推荐门店纬度' },
        { key: 'recmarketname', text: '推荐门店名称' },
        { key: 'recprovincecityarea', text: '推荐门店省市区' },
        { key: 'recaddress', text: '推荐门店地址' },
        { key: 'recscore', text: '推荐门店可信度打分' },
        { key: 'recdistance', text: '推荐门店与系统门店距离' },
      ],
      search: {
        marketid: null,
        marketname: null,
        customer: null,
        address: null,
        adminid: Number(this.$route.query.adminid) || null,
        datasource: null,
        created_at: [],
        regionids: [],
      },
      searchFieldType: {
        adminid: Number,
        regionids: Array,
      },
    }
  },
  created () {
    this.getChinaAreaData()
  },
  methods: {
    ...request.map(['getBasicPlatformUsersIndex', 'getPlatformUsersDetail']),
    getTableData (params) {
      return request.common('queryMarketCsLocationLog', params)
    },
    formatCreatedAt (row, column, cellValue) {
      if (!cellValue) {
        return ''
      }
      return String(cellValue).replace(/-/g, '/')
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.search.regionids = []
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: removeEmptyParams(_.cloneDeep(this.search)),
      })
    },
    getChinaAreaData () {
      request.alert('queryAllFormatted').then(({ data }) => {
        this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
      }).catch(() => {
        this.chinaAreaData = []
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/market/pages/MarketCsLocationLogTable.vue